import { Field, InjectedFormProps } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import { isRequired, withMessage } from 'lib/utils/formValidation';

const validate = {
  fieldValue: [withMessage('Please enter a value', isRequired)],
};

const FieldFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <>
      <Field
        component={InputField}
        label='Field value'
        name='fieldValue'
        id='fieldValue'
        disabled={submitting}
        placeholder='Field value'
        validate={validate.fieldValue}
      />
    </>
  );
};

export default FieldFields;
